export enum TwoFactorMethod {
  EMAIL = 'EMAIL',
  APP = 'APP',
  SMS = 'SMS',
}

export interface TwoFactorAuthInitiateRequest {
  method: TwoFactorMethod;
}

export interface TwoFactorAuthVerifyRequest {
  method: TwoFactorMethod;
  code: string;
}